import BaseApi from '../BaseApi';
// 站点左侧接口
export default class SiteApi extends BaseApi {
  // ***************************站点信息begin***************************
  // 1.站点详情
  async selectStationDetail(info) {
    return await this.get(`screenStationInfo/selectStationDetail`, info);
  }
  // 19.获取站点可用电池信息
  async selectStationBatteryInfo(info) {
    return await this.get(`screenStationInfo/selectStationBatteryInfo`, info);
  }
  // 2.获取高峰排队数详情数据
  async selectStationLineNum(info) {
    return await this.get(`screenStationInfo/selectStationLineNum`, info);
  }
  // ***************************站点信息end***************************

  // ***************************考核指标begin***************************
  // 3.获取站点的考核指标
  async selectStationAssessTarget(info) {
    return await this.get(`screenStationInfo/selectStationAssessTarget`, info);
  }
  //4.获取站点有效换电率
   async selectStationProportion(info) {
    return await this.get(`screenStationInfo/selectStationProportion`, info);
  }
  //5.获取客户满意度
  async selectUserSatisfiedProportion(info) {
    return await this.get(`screenStationInfo/selectUserSatisfiedProportion`, info);
  }
  //6.获取月累计碳减排
  async selectCarbonReduction(info) {
    return await this.get(`screenStationInfo/selectCarbonReduction`, info);
  }
  //7.获取安全运营天数
  async selectStationOperDayProportion(info) {
    return await this.get(`screenStationInfo/selectStationOperDayProportion`, info);
  }
  //8.获取站点运营业务收入
  async selectStationRcvAmount(info) {
    return await this.get(`screenStationInfo/selectStationRcvAmount`, info);
  }
  //9.获取订单趋势
  async selectStationOrderCurrent(info) {
    return await this.get(`screenStationInfo/selectStationOrderCurrent`, info);
  }
  //10.获取站点运营成本
  async selectStationOperCost(info) {
    return await this.get(`screenStationInfo/selectStationOperCost`, info);
  }
  // ***************************考核指标end***************************

  // ***************************运营指标end***************************
  //11.获取站点运营指标
  async selectStationOperTarget(info) {
    return await this.get(`screenStationInfo/selectStationOperTarget`, info);
  }
  //12.获取站点日均数据及负荷率、电池数据
  async selectStationOperDailyData(info) {
    return await this.get(`screenStationInfo/selectStationOperDailyData`, info);
  }
  //18.获取站点需求及电价
  async selectStationNeedsAndBillNum(info) {
    return await this.get(`screenStationInfo/selectStationNeedsAndBillNum`, info);
  }
  //13.获取站点充电成本趋势
  async selectStationChangePowerCost(info) {
    return await this.get(`screenStationInfo/selectStationChangePowerCost`, info);
  }
  //14.获取电池配置及负荷率
  async selectStationBatteryAndLoadRate(info) {
    return await this.get(`screenStationInfo/selectStationBatteryAndLoadRate`, info);
  }
  // ***************************运营指标end***************************
  // ***************************中间站点信息begin***************************
  //15.获取站点详情
  async selectStationInfo(info) {
    return await this.get(`screenStationInfo/selectStationInfo`, info);
  }
  //当天换电详情
  async selectChangeDatteryTime(info) {
    return await this.get(`screenBatteryInfo/selectChangeDatteryTime`, info);
  }
  // ***************************中间站点信息end***************************
}
export const siteLeft = new SiteApi();